import React, { useEffect, useState } from 'react'
import { ReactComponent as CloseSvg } from '../../assets/icons/close.svg'
import styles from './statistic-modal.module.scss'
import SendStatisticStepOne from './SendStatisticStepOne'
import SendStatisticStepTwo from './SendStatisticStepTwo'
import SendStatisticStepThree from './SendStatisticStepThree'
import SendStatisticStepFour from './SendStatisticStepFour'
import { batch, useDispatch, useSelector } from 'react-redux'
import Socket from '../../websocket'
import { setClearSurveyStatus, setCurrentStepAction, setSurveyStatusAction } from '../../redux/actions/ui.action'
import { confirm } from '../../UI/Confirm/Confirm'
import { useHistory } from 'react-router-dom'
import { billingStatus } from '../../helpers/helpers'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default function StatisticModal({ onClose, surveyData, surveyVacancyData }) {
  const dispatch = useDispatch()
  const route = useHistory()

  const currentStep = useSelector(({ ui }) => ui.currentStep)
  const isUserEditingProfile = () => {
    const currentPath = window.location.pathname

    const isOnProfileEditPage =
      currentPath.includes('/profile/vacancy-manager') ||
      currentPath.includes('/profile/users/users-create') ||
      currentPath.includes('/profile/company-data')

    if (!isOnProfileEditPage) {
      return false
    }

    const activeElement = document.activeElement
    if (
      activeElement &&
      (activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.contentEditable === 'true')
    ) {
      return true
    }

    const changedInputs = document.querySelectorAll(
      'input.changed, input[data-changed="true"], textarea.changed, textarea[data-changed="true"]'
    )
    const dirtyInputs = document.querySelectorAll(
      'input.dirty, input[data-dirty="true"], textarea.dirty, textarea[data-dirty="true"]'
    )
    const modifiedInputs = document.querySelectorAll('input.modified, textarea.modified, [data-modified="true"]')

    const allInputs = document.querySelectorAll(
      'input:not([type="hidden"]):not([type="button"]):not([type="submit"]), textarea, select'
    )
    let hasChangedValues = false

    allInputs.forEach((input) => {
      if (
        input.tagName === 'TEXTAREA' ||
        (input.tagName === 'INPUT' &&
          (input.type === 'text' || input.type === 'email' || input.type === 'password' || !input.type))
      ) {
        if (input.value && input.value.trim() !== '' && input.value !== (input.defaultValue || '')) {
          hasChangedValues = true
        }
      } else if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked !== input.defaultChecked) {
          hasChangedValues = true
        }
      } else if (input.tagName === 'SELECT') {
        const defaultSelected = input.querySelector('option[selected]')
        const currentSelected = input.options[input.selectedIndex]
        if (!defaultSelected || defaultSelected !== currentSelected) {
          hasChangedValues = true
        }
      }
    })

    const textareas = document.querySelectorAll('textarea')
    textareas.forEach((textarea) => {
      if (textarea.value && textarea.value.trim() !== '') {
        hasChangedValues = true
      }
    })

    const saveButtons = document.querySelectorAll(
      'button[type="submit"]:not(:disabled), .save-button:not(:disabled), .submit-button:not(:disabled)'
    )
    const enabledSaveButtons = Array.from(saveButtons).filter(
      (btn) => btn.style.display !== 'none' && !btn.hasAttribute('disabled')
    )

    return (
      changedInputs.length > 0 ||
      dirtyInputs.length > 0 ||
      modifiedInputs.length > 0 ||
      enabledSaveButtons.length > 0 ||
      hasChangedValues
    )
  }

  useEffect(() => {
    if (surveyData && surveyData.length > 0) {
      Socket.emit('company_survey.get_survey', {
        vacancy_id: surveyData[0],
      })
    }
  }, [surveyData])

  useEffect(() => {
    const body = document.documentElement
    disableBodyScroll(body)

    return () => enableBodyScroll(body)
  }, [])

  const handleClose = () => {
    onClose()
  }

  const handleStepChange = (step) => {
    dispatch(setCurrentStepAction(step))
  }

  const handleSendSeafarers = (selectedSeafarers) => {
    const vacancyId = surveyData[0]
    Socket.emit('company_survey.select_seafarers', {
      vacancy_id: vacancyId,
      seafarer_ids: selectedSeafarers,
    })
    if (surveyData.length > 1) {
      handleStepChange(1)
      return
    }
    handleStepChange(4)
  }

  const handleConfirmExplore = () => {
    dispatch(setSurveyStatusAction(false))
    route.push('/profile/billing/services')
  }
  const handleCancelExplore = () => {
    return
  }
  const handleExploreServices = () => {
    const isEditing = isUserEditingProfile()

    if (isEditing) {
      if (document.getElementById('confirm')) {
        return
      }

      confirm(
        'Are you sure you want to proceed?',
        'You have unfinished business.',
        handleConfirmExplore,
        handleCancelExplore
      )
    } else {
      handleConfirmExplore()
    }
  }

  const handleSkipStepThree = () => {
    const vacancyId = surveyData[0]
    Socket.emit('company_survey.select_seafarers', {
      vacancy_id: vacancyId,
      seafarer_ids: [],
    })
    dispatch(setCurrentStepAction(4))
  }

  const handleNotFoundVacancy = () => {
    handleStepChange(2)
    Socket.emit('company_survey.select_seafarers', {
      vacancy_id: surveyData[0],
      seafarer_ids: [],
    })
  }

  const renderCurrentStep = () => {
    if (surveyData && surveyData.no_surveys_found) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h3>Survey Not Found</h3>
          <p>Currently, there are no available surveys for you.</p>
          <button
            onClick={() => dispatch(setSurveyStatusAction(false))}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#43927C',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      )
    }
    switch (currentStep) {
      case 1:
        return (
          <SendStatisticStepOne
            onFoundYes={() => handleStepChange(3)}
            onFoundNo={() => handleNotFoundVacancy()}
            vacancyData={surveyVacancyData}
          />
        )
      case 2:
        if (!billingStatus() && surveyData.length === 0) {
          return <SendStatisticStepFour onClose={onClose} />
        } else if (!billingStatus() && surveyData.length >= 1) {
          return (
            <SendStatisticStepOne
              onFoundYes={() => handleStepChange(3)}
              onFoundNo={() => handleNotFoundVacancy()}
              vacancyData={surveyVacancyData}
            />
          )
        }
        return <SendStatisticStepTwo onExploreServices={handleExploreServices} onSkip={handleClose} />
      case 3:
        return (
          <SendStatisticStepThree
            surveyData={surveyVacancyData}
            onSend={handleSendSeafarers}
            onSkip={handleSkipStepThree}
            onExploreServices={handleExploreServices}
          />
        )
      case 4:
        return <SendStatisticStepFour onClose={onClose} />
      default:
        return (
          <SendStatisticStepOne
            onFoundYes={() => handleStepChange(3)}
            onFoundNo={() => handleNotFoundVacancy()}
            vacancyData={surveyVacancyData}
          />
        )
    }
  }

  useEffect(() => {
    return () => {
      batch(() => {
        dispatch(setClearSurveyStatus())
      })
    }
  }, [])

  return (
    <div className={styles.statisticModalOverlay}>
      <div className={styles.statisticModal}>
        {currentStep && renderCurrentStep()}
        <button onClick={handleClose} className={styles['statisticModal__close-button']}>
          <CloseSvg width={20} height={20} color="#7B958D" />
        </button>
      </div>
    </div>
  )
}
